<template>
  <div>
    <AlertMessages
      v-if="alertValue"
      :alert-type="alertType" 
      :alert-msg="alertMsg"
      @reset="alertValue = false"
    />
    <v-card
      width="100%"
      height="100%"
      class="activity-page-height edit-page"
    >
      <v-row
        v-if="published && !loadingData"
        no-gutters
        class="text-center mt-10"
      >
        <v-col cols="12">
          <v-chip
            data-testid="editing-published-quiz-chip"
            color="warning pa-6"
            text-color="black"
          >
            {{ $t('editPublishedQuizTag') }}
          </v-chip>
        </v-col>
      </v-row>
      <draggable
        v-if="!listQuestions.length && !loadingData"
        ref="dragArea"
        class="dragArea dragAreaEmptyQuiz list-group mx-auto"
        :list="listQuestions"
        group="questions"
        ghost-class="ghost-block"
      >
        <v-row
          no-gutters
          class="fill-height"
          align="center"
          data-testid="empty-page-content"
        >
          <v-col
            cols="11"
            class="mx-auto px-0"
            align="center"
          >
            <div class="greytextlight--text text-h6 text-md-h5 font-weight-bold mx-auto pa-4">
              {{ $t('emptyEditActivityQuizText') }}
            </div>                     
            <div ref="editQuiz" />
          </v-col>
        </v-row>
      </draggable>
                      
      <v-card
        max-width="960"
        class="mx-auto px-3"
        elevation="0"
      >
        <v-expansion-panels
          flat
          class="d-block"
        >
          <v-form
            ref="form_questions"
            v-model="valid"
          >
            <draggable
              v-if="listQuestions.length>0 && !loadingData"
              ref="dragArea"
              class="dragArea dragAreaQuiz list-group px-5 py-15"
              :list="listQuestions"
              group="questions"
              ghost-class="ghost-block"
              :sort="false"
              handle=".handle"
            >
              <v-expansion-panel
                v-for="(question, index) in listQuestions"
                :key="index"
                class="pa-3 mb-3 mt-3 background rounded-xxl"
              >
                <v-toolbar
                  flat
                  height="30"
                  color="background"
                >
                  <v-icon
                    v-if="index != (listQuestions.length-1) && !published "
                    class="mr-1"
                    data-testid="movedown-icon"
                    dense
                    @click="moveQuestion(index, index+1)"
                  >
                    mdi-chevron-down-box
                  </v-icon>
                  <v-icon
                    v-if="index != 0 && !published "
                    class="mr-1"
                    data-testid="moveup-icon"
                    dense
                    @click="moveQuestion(index, index-1)"
                  >
                    mdi-chevron-up-box
                  </v-icon>
                  <v-spacer />
                  <v-tooltip
                    v-if="! published"
                    top
                  >
                    <template v-slot:activator="{ on }">
                      <v-btn
                        data-testid="delete-question-button"
                        icon
                        @click="deleteQuestion(index)"
                      >
                        <v-icon
                          data-testid="delete-question-icon"
                          dense
                          v-on="on"
                        >
                          mdi-delete-circle
                        </v-icon>
                      </v-btn>
                    </template>
                    <span>{{ $t('deleteQuestion') }}</span>
                  </v-tooltip>
                </v-toolbar>
                <v-expansion-panel-header data-testid="question-header">
                  <p class="ma-0">
                    <span class="text-h6 mr-2">{{ index+1 }})</span> <span>{{ question.question }}</span>
                  </p>
                </v-expansion-panel-header>
                <v-expansion-panel-content class="grow background">
                  <v-card
                    color="background"
                    elevation="0"
                  >
                    <v-card-title class="justify-center no-break">
                      {{ $t('question') }}
                    </v-card-title>
                    <v-card-text>
                      <v-row
                        v-if="!mobile()"
                        align="center"
                      >
                        <v-img
                          class="rounded-lg custom-border text-center align-center"
                          max-width="120"
                          width="120"
                          height="90"
                          :src="question.imageDisplay != null ? question.imageDisplay : require('../../assets/quiz_images/example_image_question.png')"
                          @click="showUploadQuestionImage(question.qid)"
                        >
                          <v-progress-circular
                            v-if="loadingImage[question.qid]"
                            size="20"
                            indeterminate
                            class="mx-2 text-center justify-center"
                          />
                          <v-btn
                            v-if="question.imageDisplay != null"
                            data-testid="remove-image-button"
                            absolute
                            top
                            right
                            icon
                            style="top:0; right:0"
                            @click.stop="removeQuestionImage(question.qid)"
                          >
                            <v-icon color="darktext">
                              mdi-close-circle
                            </v-icon>
                          </v-btn>
                        </v-img>
                        <v-file-input 
                          ref="file_input_question"
                          v-model="questions[question.qid]"
                          accept="image/png, image/jpeg"
                          :ref_id="question.qid"
                          data-testid="question-image-file-input"
                          class="d-none"
                          @change="uploadQuestionImage(question.qid)"
                        />
                        <v-text-field
                          v-model="question.question"
                          data-testid="question-input"
                          solo
                          hide-details="auto"
                          class="rounded-xxl text-body-2 mx-5"
                          :rules="questionRules"
                        />
                      </v-row>
                      <v-row v-if="mobile()">
                        <v-col cols="12">
                          <v-img
                            class="mx-auto rounded-lg custom-border text-center align-center"
                            max-width="120"
                            width="120"
                            height="90"
                            :src="question.imageDisplay != null ? question.imageDisplay : require('../../assets/quiz_images/example_image_question.png')"
                            @click="showUploadQuestionImage(question.qid)"
                          >
                            <v-progress-circular
                              v-if="loadingImage[question.qid]"
                              size="20"
                              indeterminate
                              class="mx-2 text-center justify-center"
                            />
                            <v-btn
                              v-if="question.imageDisplay != null"
                              data-testid="remove-image-button"
                              absolute
                              top
                              right
                              icon
                              style="top:0; right:0"
                              @click.stop="removeQuestionImage(question.qid)"
                            >
                              <v-icon color="darktext">
                                mdi-close-circle
                              </v-icon>
                            </v-btn>
                          </v-img>
                        </v-col>
                        <v-col cols="12">
                          <v-file-input 
                            ref="file_input_question"
                            v-model="questions[question.qid]"
                            accept="image/png, image/jpeg"
                            :ref_id="question.qid"
                            data-testid="question-image-file-input"
                            class="d-none"
                            @change="uploadQuestionImage(question.qid)"
                          />
                          <v-text-field
                            v-model="question.question"
                            data-testid="question-input"
                            solo
                            hide-details="auto"
                            class="rounded-xxl text-body-2"
                            :rules="questionRules"
                          />
                        </v-col>
                      </v-row>
                    </v-card-text>
                    <v-card-title class="justify-center no-break">
                      {{ $t('answers') }}
                    </v-card-title>
                    <v-card-text v-if="question.options[0].answer != null">
                      <v-row
                        v-for="(answer, answerIndex) in question.options"
                        :key="answerIndex"
                        align="center"
                      >
                        <v-text-field
                          v-if="question.type == 1"
                          v-model="answer.answer"
                          data-testid="answer-input"
                          solo
                          hide-details="auto"
                          class="rounded-xxl text-body-2 mx-5"
                          :rules="answerRules"
                        >
                          <template v-slot:prepend-inner>        
                            <v-icon
                              v-if="answer.isTrue"
                              :disabled="published == true"
                              color="accent"
                              data-testid="answer-input-truth"
                              @click="changeRightAnswer(question, answerIndex)"
                            >
                              mdi-radiobox-marked
                            </v-icon>
                            <v-icon
                              v-else
                              :disabled="published == true"
                              data-testid="answer-input-truth"
                              @click="changeRightAnswer(question, answerIndex)"
                            >
                              mdi-radiobox-blank
                            </v-icon> 
                          </template>
                        </v-text-field>
                        <v-text-field
                          v-else
                          v-model="answer.answer"
                          data-testid="answer-input"
                          solo
                          hide-details="auto"
                          class="rounded-xxl text-body-2 mx-5"
                          :rules="answerRules"
                        >
                          <template v-slot:prepend-inner>        
                            <v-icon
                              v-if="answer.isTrue"
                              :disabled="published == true"
                              color="accent"
                              data-testid="answer-input-truth"
                              @click="changeRightAnswer(question, answerIndex)"
                            >
                              mdi-checkbox-outline
                            </v-icon>
                            <v-icon
                              v-else
                              :disabled="published == true"
                              data-testid="answer-input-truth"
                              @click="changeRightAnswer(question, answerIndex)"
                            >
                              mdi-checkbox-blank-outline
                            </v-icon> 
                          </template>
                        </v-text-field>
                        <v-tooltip
                          v-if="! published"
                          top
                        >
                          <template v-slot:activator="{ on }">
                            <v-btn
                              data-testid="delete-answer-button"
                              icon
                              :disabled="question.options.length == 2"
                              @click="deleteAnswer(question, answerIndex, answer.isTrue)"
                            >
                              <v-icon
                                data-testid="delete-answer-icon"
                                dense
                                v-on="on"
                              >
                                mdi-delete-circle
                              </v-icon>
                            </v-btn>
                          </template>
                          <span>{{ $t('deleteAnswer') }}</span>
                        </v-tooltip>
                      </v-row>
                      <v-btn
                        v-if="question.options.length < 20 && ! published"
                        data-testid="answer-plus-button"
                        icon
                        class="mx-auto d-block"
                        @click="addAnswer(question)"
                      >
                        <v-icon>mdi-plus</v-icon>
                      </v-btn>
                    </v-card-text>
                    <v-card-text v-else>
                      <v-row>
                        <v-col
                          v-for="(answer, answerIndex) in question.options"
                          :key="answerIndex"
                          align="center"
                          align-md="left"
                          cols="12"
                          md="6"
                          lg="4"
                        >
                          <v-card
                            rounded="xxl"
                            width="250px"
                          >
                            <v-row
                              align="center"
                              justify="center"
                              class="pa-3"
                            >
                              <div v-if="question.type == 1">
                                <v-icon
                                  v-if="answer.isTrue"
                                  :disabled="published == true"
                                  color="accent"
                                  data-testid="answer-input-truth"
                                  @click="changeRightAnswer(question, answerIndex)"
                                >
                                  mdi-radiobox-marked
                                </v-icon>
                                <v-icon
                                  v-else
                                  :disabled="published == true"
                                  data-testid="answer-input-truth"
                                  @click="changeRightAnswer(question, answerIndex)"
                                >
                                  mdi-radiobox-blank
                                </v-icon> 
                              </div>
                              <div v-else>
                                <v-icon
                                  v-if="answer.isTrue"
                                  :disabled="published == true"
                                  color="accent"
                                  data-testid="answer-input-truth"
                                  @click="changeRightAnswer(question, answerIndex)"
                                >
                                  mdi-checkbox-outline
                                </v-icon>
                                <v-icon
                                  v-else
                                  :disabled="published == true"
                                  data-testid="answer-input-truth"
                                  @click="changeRightAnswer(question, answerIndex)"
                                >
                                  mdi-checkbox-blank-outline
                                </v-icon> 
                              </div>
                              <v-img
                                class="rounded-lg custom-border text-center align-center mx-5"
                                max-width="120"
                                width="120"
                                height="90"
                                :src="answer.imageDisplay != null ? answer.imageDisplay : require('../../assets/quiz_images/example_image_answer.png')"
                                @click="showUploadAnswerImage(answer.aid)"
                              >
                                <v-progress-circular
                                  v-if="loadingImage[answer.aid]"
                                  size="20"
                                  indeterminate
                                  class="mx-2 text-center justify-center"
                                />                            
                              </v-img>
                              <v-file-input 
                                ref="file_input_answer"
                                v-model="answers[answer.aid]"
                                accept="image/png, image/jpeg"
                                :ref_id="answer.aid"
                                data-testid="answer-image-file-input"
                                class="d-none"
                                @change="uploadAnswerImage(question.qid, answer.aid)"
                              />
                              <v-tooltip
                                v-if="! published"
                                top
                              >
                                <template v-slot:activator="{ on }">
                                  <v-btn
                                    width="24px"
                                    data-testid="delete-answer-button"
                                    icon
                                    :disabled="question.options.length == 2"
                                    @click="deleteAnswer(question, answerIndex, answer.isTrue)"
                                  >
                                    <v-icon
                                      data-testid="delete-answer-icon"
                                      dense
                                      v-on="on"
                                    >
                                      mdi-delete-circle
                                    </v-icon>
                                  </v-btn>
                                </template>
                                <span>{{ $t('deleteAnswer') }}</span>
                              </v-tooltip>
                            </v-row>
                          </v-card>
                          <div
                            v-if="answer.imageDisplay == null"
                            class="error--text text-caption text-center text-lg-left"
                          >
                            {{ $t('imageErrorRequired') }}
                          </div>
                        </v-col>
                      </v-row>
                      <v-btn
                        v-if="question.options.length < 20 && ! published"
                        data-testid="answer-plus-button"
                        icon
                        class="mx-auto d-block"
                        @click="addAnswer(question)"
                      >
                        <v-icon>mdi-plus</v-icon>
                      </v-btn>
                    </v-card-text>
                    <v-card-title class="justify-center no-break">
                      Feedback
                    </v-card-title>
                    <v-card-text class="mx-auto" style="width: 80%;">
                      <v-textarea
                        v-model="question.feedback_wrong_answer"
                        data-testid="feedback-wrong-textarea"
                        elevation="6"
                        class="rounded-xxl text-body-2"
                        solo
                        placeholder="Leave your feedback for the answers that are wrong here"
                        rows="3"
                        :rules="feedbackRules"
                      />
                      <v-textarea
                        v-model="question.feedback_correct_answer"
                        data-testid="feedback-correct-textarea"
                        elevation="6"
                        class="rounded-xxl text-body-2 mt-3"
                        solo
                        placeholder="Leave your feedback for the answers that are right here"
                        rows="3"
                        :rules="feedbackRules"
                      />
                    </v-card-text>
                  </v-card>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </draggable>
          </v-form>
        </v-expansion-panels>
      </v-card>
    </v-card>
    <v-navigation-drawer
      app
      permanent
      right
      clipped
      data-testid="navigation-drawer"
      width="300"
    >
      <template
        v-if="!loadingData"
        v-slot:prepend
      >
        <v-row class="ma-0">
          <v-col cols="5">   
            <v-tooltip
              v-if="loadingAutosave && !published"
              top
            >
              <template
                v-slot:activator="{ on }"
              >
                <v-icon
                  data-testid="saving-draft-icon"
                  dense
                  class="mr-2"
                  v-on="on"
                  @click="autosaveQuizAsDraft(false)"
                >
                  mdi-cloud-sync-outline
                </v-icon>
              </template>
              <span>{{ $t('savingTooltip') }}</span>
            </v-tooltip>
            <v-tooltip
              v-if="!loadingAutosave && !published"
              top
            >
              <template
                v-slot:activator="{ on }"
              >
                <v-icon
                  data-testid="save-draft-icon"
                  dense
                  class="mr-2"
                  v-on="on"
                  @click="autosaveQuizAsDraft(false)"
                >
                  mdi-cloud-outline
                </v-icon>
              </template>
              <span>{{ $t('saveAsDraftTooltip') }}</span>
            </v-tooltip>
            <div
              class="text-caption grey--text font-weight-regular pt-1"
              style="height:20px; line-height:1;"
            >
              {{ loadingAutosaveFinish ? $t('saveAsDraftSuccess') : '' }}
            </div>                  
          </v-col>
          <v-col
            cols="7"
            align="right"
          >                    
            <v-btn
              v-if="!published && listQuestions.length > 0"
              data-testid="submit-button"
              class="rounded-xxl text-none px-10"
              color="success"
              dark 
              @click="
                dialogPublishVisible=true, 
                confirmationDialogTitle=$t('confirmationDialogTitlePublishQuiz'), 
                confirmationDialogText=$t('confirmationDialogTextPublishQuiz'), 
                confirmationDialogSubmitBtn=$t('publish')
                confirmationDialogCancelBtn=$t('saveAsDraft')"
            >
              {{ $t('publish') }}
            </v-btn>

            <v-btn
              v-else-if="! published && listQuestions.length == 0"
              data-testid="submit-button"
              class="rounded-xxl text-none px-10"
              color="success"
              dark 
              @click="
                dialogNoQuestionVisible=true, 
                confirmationDialogTitle=$t('confirmationDialogTitleNoQuestionsInQuiz'), 
                confirmationDialogText=$t('confirmationDialogTextNoQuestionsInQuiz'), 
                confirmationDialogSubmitBtn=$t('saveAsDraft')
                confirmationDialogCancelBtn=$t('cancel')"
            >
              {{ $t('publish') }}
            </v-btn>

            <v-btn
              v-else
              data-testid="submit-button-publish-changes"
              class="rounded-xxl text-none px-10"
              color="success"
              dark 
              @click="
                dialogPublishChangesVisible=true, 
                confirmationDialogTitle=$t('confirmationDialogTitleUpdateQuiz'), 
                confirmationDialogText=$t('confirmationDialogTextUpdateQuiz'), 
                confirmationDialogSubmitBtn=$t('confirmBtn')
                confirmationDialogCancelBtn=$t('cancel')"
            >
              {{ $t('publish') }}
            </v-btn>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="6"> 
            <div
              class="d-flex flex-column"
              style="align-items:center"
            >    
              <v-btn
                icon
                class="mr-0 text-none"
                :class="{'accent--text': showQustionTypes}"
                data-testid="qustion-types-button"
                @click="showQustionTypes = true, showSettings = false"
              >
                <v-icon class="mx-auto">
                  mdi-chat-question-outline
                </v-icon>
              </v-btn>                
              <span
                :style="{cursor: 'pointer'}"
                :class="{'accent--text':showQustionTypes}"
                @click="showQustionTypes = true, showSettings = false"
              >{{ $t('questionTypes') }}</span>
            </div>
          </v-col>
          <v-col cols="6"> 
            <div
              class="d-flex flex-column"
              style="align-items:center"
            >  
              <v-btn
                icon
                class="mr-0 text-none"
                :class="{'accent--text': showSettings}"
                data-testid="settings-button"
                @click="showSettings = true, showQustionTypes = false"
              >
                <v-icon class="mx-auto">
                  mdi-cog
                </v-icon>
              </v-btn>                    
              <span
                :style="{cursor: 'pointer'}"
                :class="{'accent--text': showSettings}"
                @click="showSettings = true, showQustionTypes = false"
              >{{ $t('settingsEditQuiz') }}</span>
            </div>
          </v-col>
        </v-row>
        <v-divider />
      </template>

      <v-tooltip
        v-if="showQustionTypes && !loadingData"
        left
        :disabled="! published"
      >
        <template v-slot:activator="{ on }">
          <v-card
            height="100%"
            elevation="0"
            class="px-2"
            data-testid="blocks-card"
            v-on="on"
          >
            <div>
              <draggable
                class="dragArea pb-5"
                :list="listQuestionTypes"
                :group="{ name: 'questions', pull: 'clone', put: listQuestionTypes }"
                :clone="dragDropQuestionToPageLayout"
                :sort="false"
                chosen-class="chosen-block"
                :disabled="published"
              >
                <v-card
                  v-for="(type, index) in listQuestionTypes"
                  :key="index"
                  class="question-block"
                  data-testid="question-types-card"
                  :ripple="false"
                  @click="addQuestionToPageLayout(type.id, type.answersType)"
                  elevation="4"
                >
                  <v-card-subtitle data-testid="question-type-title-card">
                    {{ type.name }}
                  </v-card-subtitle>
                  <v-img
                    data-testid="question-type-img-card"
                    :src="getImgUrl(type.image)"
                  />
                  <v-card-actions>
                    <v-btn
                      data-testid="question-type-button-card"
                      text
                      class="mx-auto text-none text-body-2 greytext--text rounded-xxl"
                    >
                      {{ $t('addQuestionToQuizLink') }}
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </draggable>
            </div>
          </v-card>
        </template>
        <span>{{ $t('editPublishedQuizTag') }}</span>
      </v-tooltip>
      <v-card
        v-if="!loadingData"
        :style="{visibility: showSettings ? 'visible' : 'hidden'}"
        height="100%"
        elevation="0"
        class="px-4"
        data-testid="blocks-card"
      >
      <v-row>
          <v-col>
            <v-icon size="24px" color="warning">mdi-exclamation-thick</v-icon>
            <span class="text-body-2">{{ $t('editQuizChangesSaved') }}</span>
          </v-col>
        </v-row>
        <v-form
          ref="form"
          v-model="valid"
          data-testid="setiings-card"
        >
          <v-row>
            <v-col>
              <v-card class="rounded-xxl pa-2">
                <v-card-title class="pa-2 text-body-1 text-center justify-center">{{ $t('coverImage')}}</v-card-title>
                <img class="mx-auto d-block quiz-start-image-edit rounded-0"
                data-testid="image-quiz-card" :src="startUrl ? startUrl : require('../../assets/quiz_start.png')">
                <v-card-actions class="ma-0 px-0 pb-0 pt-2">
                  <v-btn data-testid="upload-button" :loading="loadingUpload" :disabled="loadingUpload" color="white"
                    class="text-body-1 darktext--text text-none rounded-xxl px-4 d-block" @click="showUploadImage" width="100%">
                    {{ $t('uploadNew') }}
                  </v-btn>
                  <v-file-input ref="file_input" v-model="imageData" accept="image/png, image/jpeg" prepend-icon="mdi-camera"
                    data-testid="file-input" class="d-none" @change="uploadStartImage" />
                </v-card-actions>
                <ConfirmationDialogCropper v-if="dialogVisibleCropper" ref="confirmationDialog" :visible="dialogVisibleCropper"
                  :image-to-crop="imageToCropOnUpload ? imageToCropOnUpload : '../../assets/quiz_start.png'"
                  :image-type="imageTypeOnUpload" :crop-on-upload="cropOnUpload" data-testid="confirmation-dialog"
                  @close="closeCropImage" @crop="cropImage" />
              </v-card>
            </v-col>
          </v-row>
          <v-row>
            <v-col
              cols="12"
              class="pt-5"
            >
              <p class="normal">
                {{ $t('textAllowedAttempts') }}
              </p>
            </v-col>
            <v-col
              cols="12"
              class="py-0"
            > 
              <v-select
                v-model="numberAttempt"
                style="font-size:12px"
                data-testid="number-attempts-input" 
                solo 
                class="rounded-xxl select-items"
                hide-details="true"
                append-icon="mdi-chevron-down" 
                dense 
                :items="itemsAttempts" 
                item-text="name" 
                return-object 
                :menu-props="{ maxHeight: 350 }"   
                @change="updateAttemptsInActivityQuiz"
              >
                <template v-slot:item="{item}">
                  <!-- eslint-disable-next-line vue/no-v-html -->
                  <span v-html="item.name" />
                </template>
              </v-select>
            </v-col>
          </v-row>
          <br>
          <v-row class="pa-0">
            <v-col
              cols="12"
              class="py-0"
            >
              <v-checkbox
                v-model="checkboxScoreToPess"
                class="checkbox-scoore-to-pess"
                data-testid="checkbox-scoore-to-pess"
                :label="$t('checkboxScoreToPessLabel')"
                color="accent"
                @change="updateCheckboxScoreToPess"
              />
            </v-col>
          </v-row>
          <v-row v-if="checkboxScoreToPess == true">
            <v-col
              cols="6"
              class="py-0"
            > 
              <v-text-field
                v-model="numberPercent"
                data-testid="percents-input"
                type="number"
                :max="100"
                :min="0"
                solo
                hide-details="auto"
                class="rounded-xxl text-body-2 percent-quiz px-0"
                :rules="numberPercentRules"
                @change="updatePersentInActivityQuiz"
              >
                <template v-slot:append>        
                  <v-icon
                    size="18"
                    class="pl-0 py-2 pr-2 "
                  >
                    mdi-percent-outline
                  </v-icon>
                </template>
              </v-text-field> 
            </v-col>
            <v-col
              v-if="calculateScore >= 0 && calculateScore <= 100 "
              cols="6"
            >
              <p class="small">
                {{ $t('textPercentQuiz', { calculateScore: calculateScore }) }}
              </p>
            </v-col>
          </v-row>
          <v-row v-if="checkboxScoreToPess == true">
            <v-col
              cols="12"
              class="py-0"
            >
              <p class="small">
                {{ $t('text2PercentQuiz') }}
              </p>
            </v-col>
          </v-row>
        </v-form>
      </v-card>
    </v-navigation-drawer>
    <ConfirmationDialog
      v-if="dialogPublishVisible"
      ref="confirmationDialogPublish"
      :visible="dialogPublishVisible"
      :cd-title="confirmationDialogTitle"
      :cd-text="confirmationDialogText"
      :cd-submit-btn="confirmationDialogSubmitBtn"
      :cd-cancel-btn="confirmationDialogCancelBtn"
      cd-submit-btn-color="accent"
      data-testid="confirmation-dialog-publish"
      @input="clickOutside"
      @close="saveQuiz(false)"
      @proceedSubmit="saveQuiz(true)"
    />
    <ConfirmationDialog
      v-if="dialogPublishChangesVisible"
      ref="confirmationDialogPublishChanges"
      :visible="dialogPublishChangesVisible"
      :cd-title="confirmationDialogTitle"
      :cd-text="confirmationDialogText"
      :cd-submit-btn="confirmationDialogSubmitBtn"
      :cd-cancel-btn="confirmationDialogCancelBtn"
      cd-submit-btn-color="accent"
      data-testid="confirmation-dialog-publish-changes"
      @close="dialogPublishChangesVisible=false"
      @proceedSubmit="saveQuiz(true, true)"
    />
    <ConfirmationDialog
      v-if="dialogNoQuestionVisible"
      ref="noQuestionDialog"
      :visible="dialogNoQuestionVisible"
      :cd-title="confirmationDialogTitle"
      :cd-text="confirmationDialogText"
      :cd-submit-btn="confirmationDialogSubmitBtn"
      :cd-cancel-btn="confirmationDialogCancelBtn"
      cd-submit-btn-color="accent"
      data-testid="confirmation-dialog-no-question"
      @input="clickOutside"
      @close="dialogNoQuestionVisible=false;"
      @proceedSubmit="saveQuiz(false)"
    />
  </div>
</template>
<script>
import i18n from '../../plugins/i18n'
import ConfirmationDialog from '../../components/ConfirmationDialog';
import AlertMessages  from '../../components/AlertMessages'
import { uuid } from 'vue-uuid';
import draggable from "vuedraggable";
import { repeatedMethodsMixin } from '../../mixins/repeatedMethodsMixin'
import { getActivity, getActivityQuiz, updateActivityQuiz, addQuestionsInActivityQuiz, getQuestionTypesInActivityQuiz, uploadImageInActivityQuiz, getActivityQuizQuestions, getImageURLsInActivityQuiz} from '../../api/activityApi'
import { ruleRequired} from '../../rules/formRules.js';
import ConfirmationDialogCropper from '../../components/ConfirmationDialogCropper';
import { ruleEmptyOrMin2Characters } from "../../rules/formRules.js";

export default {
    components: {
        draggable,
        ConfirmationDialog,
        AlertMessages,
        ConfirmationDialogCropper
    },
    mixins: [repeatedMethodsMixin],
    data(){
         return{
            quizId: this.$route.params.quizId,
            activityId: this.$route.params.id,
            loadingData: false,
            alertMsg: '',
            alertType: '',
            alertValue:false,
            dialogPublishVisible: false,
            dialogPublishChangesVisible: false,
            dialogNoQuestionVisible: false,
            confirmationDialogTitle: '',
            confirmationDialogText: '',
            confirmationDialogCancelBtn: '',
            confirmationDialogSubmitBtn: '',
            spaceId: window.$cookies.get('space_id'),
            listQuestionTypes: [],
            listQuestions:[],
            exampleQuestion: "This is an example question please change this to your own",
            exampleAnswer: "Example answer please change this to your own",
            questions: [],
            answers: [],
            loadingImage:[],
            questionRules: ruleRequired('labelQuestion'),
            answerRules: ruleRequired('labelAnswer'),
            published: false,
            valid: true,
            showImageRequiredError: false,
            showQustionTypes: true,
            showSettings: false,
            checkboxScoreToPess:false,
            numberPercent:75,
            numberPercentRules: ruleRequired('numberField'),
            numberAttempt:{id: '0',name: 'Unlimited'},
            itemsAttempts: [
                {id: '1', name: '1'},
                {id: '2', name: '2'},
                {id: '3', name: '3'},
                {id: '4', name: '4'},
                {id: '5', name: '5'},
                {id: '6', name: '6'},
                {id: '7', name: '7'},
                {id: '8', name: '8'},
                {id: '9', name: '9'},
                {id: '10', name: '10'},
                {id: '0', name: 'Unlimited'},
            ],
            preventRedirect: false,
            loadingAutosave: false,
            loadingAutosaveFinish: false,
            occupyInterval:null,
            role:'',
            loadingUpload: false,
            dialogVisibleCropper: false,
            dialogVisibleVideoEmbed: false,
            imageToCropOnUpload: null,
            imageTypeOnUpload: '',
            cropOnUpload: false,
            imageData: null,
            startUrl: null,
            startPath: null,
            feedbackRules: ruleEmptyOrMin2Characters('labelFeedback'),
        }
    },
    computed: {
        calculateScore() {
                if(this.numberPercent >= 0 && this.numberPercent <= 100){
                    var precalculateScoore  = Math.ceil(this.listQuestions.length/ 100 * this.numberPercent)
                }
                return precalculateScoore
        },
        productPlan() {
        return this.$store.state.productPlan;
      }, 
    },
    mounted() {
      if(this.productPlan.attributes && this.productPlan.attributes.name != 'Free'){
        this.occupyEditor(); 
        this.occupyInterval = setInterval(() => {         
          this.occupyEditor(); 
        }, 60000) 
      }
    },
    async created(){
        this.loadingData = true
        await this.getActivity()
        if (this.role == 'participant' || this.role == 'guest') {
          this.$router.push({name: 'PageAccessDenied'})
        }
        await this.getQuiz()
        this.showQustionTypes = true
        this.showSettings = false
        await this.getQuestionTypes()
        await this.getActivityQuizQuestions()
        this.loadingData = false

        this.$watch('listQuestions', function () {
            if(!this.preventRedirect){
                this.preventRedirect = true
                if(!this.published){
                    this.autosaveInterval = setInterval(() => this.autosaveQuizAsDraft(true), 15000);
                }
            }
        }, {deep:true})

        //if someone else is editing
        if(this.$store.state.list.find(user => user.entity_id == this.quizId )){
            this.$router.push({name: 'ViewActivityQuiz', params: {id: this.activityId, quizId: this.quizId, preventEditing: true}})
        }
    },
    beforeMount() {
        window.addEventListener("beforeunload", this.preventNav)
    },

    beforeDestroy() {
        window.removeEventListener("beforeunload", this.preventNav);
        clearInterval(this.autosaveInterval)
        clearInterval(this.occupyInterval)

    },

    methods:{
        occupyEditor(){
          var payload = {'key1': this.quizId, 'key2': this.activityId,'key3': 'quiz' }
            this.$store.dispatch("occupyEditor", payload).catch(() => {
                    this.alertValue = true
                    this.alertType = 'error'
                    this.alertMsg =  i18n.t('serverError') 
                  
              })
        },
        releaseEditor(){
          var payload = {'key1': this.quizId, 'key2': this.activityId,'key3': 'quiz' }
          this.$store.dispatch("releaseEditor", payload)
          .catch(() => {
              this.alertValue = true
              this.alertType = 'error'
              this.alertMsg =  i18n.t('serverError') 
            
        })
        },
        async getActivity(){
            try {
                const response = await getActivity(this.activityId)
                if(response.status == 200) {
                    this.role = response.data.data.attributes.role
                     }
            } catch (e) {
                if(e.response){
                    if(e.response.status == 404) {
                        if(this.isAuth){
                            this.$router.push({name: 'PageNotFound'})
                        }else{
                            this.$router.push({name: 'CustomLogin', query: {referer: this.$route.fullPath}})
                        }
                    }else if(e.response.status == 403){
                        this.$router.push({name: 'PageAccessDenied'})
                    }else {
                        this.alertValue = true
                        this.alertType = 'error'
                        this.alertMsg =  i18n.t('serverError')
                    }
                }
            }
        },
        async updateCheckboxScoreToPess(){
            const score = parseInt(this.numberPercent)
            let dataQuiz = {
                data: {
                    type: "quizzes",
                    id: this.quizId,
                    attributes: {
                        has_passing_score: this.checkboxScoreToPess,
                        passing_score: score
                    },
                    relationships: {
                        activity: {
                            data: {
                                type: "activities",
                                id: this.$route.params.id
                            }
                        }
                    }
                }
            };

            const responseQuiz = await updateActivityQuiz(this.quizId, dataQuiz)
            if (responseQuiz && responseQuiz.status == 200) {
                //
            }
            else{
                this.alertValue = true
                this.alertType = 'error';
                this.alertMsg =  i18n.t('serverError');
            }
        },
        async updatePersentInActivityQuiz(){
            const score = parseInt(this.numberPercent)
            let dataQuiz = {
                data: {
                    type: "quizzes",
                    id: this.quizId,
                    attributes: {
                        has_passing_score: this.checkboxScoreToPess,
                        passing_score: score
                    },
                    relationships: {
                        activity: {
                            data: {
                                type: "activities",
                                id: this.$route.params.id
                            }
                        }
                    }
                }
            };

            const responseQuiz = await updateActivityQuiz(this.quizId, dataQuiz)
            if (responseQuiz.status == 200) {
                //
            }
            else{
                this.alertValue = true
                this.alertType = 'error';
                this.alertMsg =  i18n.t('serverError');
            }
        },
        async updateAttemptsInActivityQuiz(){
            const numberAttempts = parseInt(this.numberAttempt.id)
            let dataQuiz = {
                data: {
                    type: "quizzes",
                    id: this.quizId,
                    attributes: {
                          allowed_attempts: numberAttempts
                    },
                    relationships: {
                        activity: {
                            data: {
                                type: "activities",
                                id: this.$route.params.id
                            }
                        }
                    }
                }
            };

            const responseQuiz = await updateActivityQuiz(this.quizId, dataQuiz)
            if (responseQuiz.status == 200) {
                  //
            }
            else{
                this.alertValue = true
                this.alertType = 'error';
                this.alertMsg =  i18n.t('serverError');
            }
        },
        async getQuiz(){
            try {
                const response_page = await getActivityQuiz(this.$route.params.quizId)
                if(response_page.status == 200) {
                    this.published = response_page.data.data.attributes.published
                    this.checkboxScoreToPess = response_page.data.data.attributes.has_passing_score
                    this.numberPercent = response_page.data.data.attributes.passing_score
                    this.numberAttempt = response_page.data.data.attributes.allowed_attempts
                    if(this.numberAttempt != 0){
                      this.numberAttempt = { id: JSON.stringify(response_page.data.data.attributes.allowed_attempts), name: JSON.stringify(response_page.data.data.attributes.allowed_attempts) }
                    }else if(this.numberAttempt == 0){
                      this.numberAttempt= {id: '0',name: 'Unlimited'}
                    }
                    if(this.numberPercent != null){
                        this.numberPercent = response_page.data.data.attributes.passing_score

                    }else if(this.numberPercent == null){
                        this.numberPercent = 75
                    }
                    this.startPath = response_page.data.data.attributes.start_image
                    this.startUrl = this.startPath ? await this.changeImageURLs(this.startPath) : null
                    
                }  
            } catch (e) {
                if(e.response){
                    this.alertValue = true
                    if(e.response.status == 404) {
                         this.$router.push({name: 'PageNotFound'})
                    }else {
                        this.alertType = 'error';
                        this.alertMsg =  i18n.t('serverError');
                    }
                } 
            }
        },
        async getActivityQuizQuestions(){
            try {
                const response = await getActivityQuizQuestions(this.quizId)
                if(response.status == 200) {
                    for (const value of response.data.data) {
                        var responseQuestionImageURL = await this.changeImageURLs(value.attributes.image)    
                        var options= []
                        for (const answer of value.attributes.options) {
                            var responseAnswerImageURL = await this.changeImageURLs(answer.image)   
                            options.push(
                                {
                                    aid: answer.aid,
                                    answer: answer.answer,
                                    image: answer.image,
                                    imageDisplay: responseAnswerImageURL,
                                    isTrue: answer.isTrue
                                }
                            )
                        }
                        
                        this.listQuestions.push({
                            qid: value.id,
                            id: value.id, 
                            question: value.attributes.question,
                            image: value.attributes.image,
                            imageDisplay: responseQuestionImageURL,
                            type: value.attributes.type,
                            options: options,
                            feedback_wrong_answer: value.attributes.feedback_wrong_answer,
                            feedback_correct_answer: value.attributes.feedback_correct_answer,        
                        });
                    }
                }    
            } catch (e) {
              if(e.response){
                   if(e.response.status == 404) {
                     this.$router.push({name: 'PageNotFound'})
                    }else{
                        this.alertValue = true
                        this.alertType = 'error';
                        this.alertMsg= i18n.t('dataNotRetrievedError')
                    } 
                }            
            }
        },
        async changeImageURLs(value){
          var imagesToCheck = []
            if(value != null){
                imagesToCheck = [value]
                
                let dataImage = {
                    data: {
                        type: "quizzes", 
                        id: this.quizId,
                        attributes: {
                            paths: imagesToCheck,
                            space_id: this.spaceId
                        }
                    }
                };
                
                const responseImageQuestion = await getImageURLsInActivityQuiz(this.quizId, dataImage)
                return responseImageQuestion.data.meta.files[value]
            }else {
                return null
            }            
        },
        async getQuestionTypes(){
            try {
                const response = await getQuestionTypesInActivityQuiz()
                if(response){
                    if(response.status == 200) {                        
                        response.data.data.forEach(type => {
                            if(type.id == 1){
                                this.listQuestionTypes.push({ id: type.id, answersType:"text", name: i18n.t("singleChoiceTextAnswers"), image: "singlechoicequestion_textanswers.jpg"})
                                this.listQuestionTypes.push({ id: type.id, answersType:"image", name: i18n.t("singleChoiceImageAnswers"), image: "singlechoicequestion_imageanswers.jpg"})
                            }
                            if(type.id == 2){
                                this.listQuestionTypes.push({ id: type.id, answersType:"text", name: i18n.t("multipleChoiceTextAnswers"), image: "multiplechoicequestion_textanswers.jpg"})
                                this.listQuestionTypes.push({ id: type.id, answersType:"image", name: i18n.t("multipleChoiceImageAnswers"), image: "multiplechoicequestion_imageanswers.jpg"})
                            }
                        })
                    }                    
                }            
            } catch (e) {
                if(e.response){
                    this.alertValue = true
                    this.alertType = 'error'
                    this.alertMsg =  i18n.t('serverError')
                }            
            }
        },
        dragDropQuestionToPageLayout(evt) {
            if (! this.published ) {
                return {
                    qid: uuid.v4(),
                    question: this.exampleQuestion,
                    image: null,
                    imageDisplay: null,
                    type: evt.id,
                    options: [
                    {
                        aid: uuid.v4(),
                        answer: evt.answersType == 'text' ? this.exampleAnswer : null,
                        image: null,
                        imageDisplay: null,
                        isTrue: false
                    },
                    {
                        aid: uuid.v4(),
                        answer: evt.answersType == 'text' ? this.exampleAnswer : null,
                        image: null,
                        imageDisplay: null,
                        isTrue: true
                    }],
                    feedback_wrong_answer: null,
                    feedback_correct_answer: null
                };
            }
        },
        addQuestionToPageLayout(type, answersType) {
            if (! this.published ) {
                this.listQuestions.push({
                    qid: uuid.v4(),
                    question: this.exampleQuestion,
                    image: null,
                    imageDisplay: null,
                    type: type,
                    options: [
                    {
                        aid: uuid.v4(),
                        answer: answersType == 'text' ? this.exampleAnswer : null,
                        image: null,
                        imageDisplay: null,
                        isTrue: false
                    },
                    {
                        aid: uuid.v4(),
                        answer: answersType == 'text' ? this.exampleAnswer : null,
                        image: null,
                        imageDisplay: null,
                        isTrue: true
                    }],
                    feedback_wrong_answer: null,
                    feedback_correct_answer: null
                });
            }
        },
        getImgUrl(element) {
            var images = require.context('../../assets/quiz_images', false, /\.jpg$/)
            return images('./' + element)           
        },
        moveQuestion(from, to) {
            this.listQuestions.splice(to, 0, this.listQuestions.splice(from, 1)[0])
        },
        deleteQuestion(element){
            this.listQuestions.splice(element, 1);
        },
        deleteAnswer(question, index, rightAnswer){
            var questionItem = this.listQuestions.find(item => item.qid === question.qid)
            questionItem.options.splice(index, 1)
            if(questionItem.type == 1 && rightAnswer == true){
                questionItem.options[0].isTrue = true
            }
            if(questionItem.type == 2 && rightAnswer == true){
                const countRightAnswers = questionItem.options.reduce((counter, obj) => obj.isTrue == true ? counter += 1 : counter, 0);
                if(countRightAnswers == 0){
                    questionItem.options[0].isTrue = true
                }
            }
        },
        async uploadQuestionImage(qid){
            if(this.questions[qid]){
                if(this.questions[qid].size > 5*1024*1024){
                    this.alertType = 'error'
                    this.alertMsg =  i18n.t('uploadCoverError')
                    this.alertValue = true
                }else {
                    this.loadingImage[qid] = true
                    try {
                        let data = new FormData();
                        data.append('file', this.questions[qid]);
                        data.append('type', 'question');
                        data.append('space_id', this.spaceId);

                        const response = await uploadImageInActivityQuiz(this.quizId,data) 
                        if(response.status == 200) {
                            this.loadingImage[qid] = false
                            var questionItem = this.listQuestions.find(item => item.qid === qid)
                            questionItem.imageDisplay = URL.createObjectURL(this.questions[qid])
                            questionItem.image = response.data.meta.detail
                            
                        }
                    } catch (e) {
                        if(e.response){
                            if (e.response.status == 422 ){
                                for(let i = 0; i < e.response.data.errors.length; i++){
                                    this.alertValue = true
                                    this.alertType = 'error'
                                    if(e.response.data.errors[i].meta[0].code == 'extensionUnsupported' || e.response.data.errors[i].meta[0].code == 'fileOversize'){
                                        this.alertMsg =  i18n.t('uploadCoverError')
                                    }else {
                                        this.alertMsg = i18n.t('serverError')
                                    }
                                }
                            } else if (e.response.status == 403){
                                for(let i = 0; i < e.response.data.errors.length; i++){
                                    if(e.response.data.errors[i].detail == 'Storage is full'){
                                        this.alertValue = true
                                        this.alertType = 'error'
                                        this.alertMsg =  i18n.t('storageFullError')
                                    }
                                    else {
                                        this.$router.push({name: 'PageAccessDenied'})
                                    }
                                }
                            } else {
                                this.alertType = 'error'
                                this.alertValue = true
                                this.alertMsg =  i18n.t('serverError')       
                            }                     
                        }
                        this.loadingImage[qid] = false
                    }
                }
            }       
        },
        async uploadAnswerImage(qid, aid){
            if(this.answers[aid]){
                if(this.answers[aid].size > 5*1024*1024){
                    this.alertType = 'error'
                    this.alertMsg =  i18n.t('uploadCoverError')
                    this.alertValue = true
                }else {
                    this.loadingImage[aid] = true
                    try {
                        let data = new FormData();
                        data.append('file', this.answers[aid]);
                        data.append('type', 'answer');
                        data.append('space_id', this.spaceId);

                        const response = await uploadImageInActivityQuiz(this.quizId,data) 
                        if(response.status == 200) {
                            this.loadingImage[aid] = false
                            var questionItem = this.listQuestions.find(item => item.qid === qid)
                            var answerItem = questionItem.options.find(item => item.aid === aid)
                            answerItem.imageDisplay = URL.createObjectURL(this.answers[aid])    
                            answerItem.image = response.data.meta.detail
                        }
                    } catch (e) {
                        if(e.response){
                            if (e.response.status == 422 ){
                                for(let i = 0; i < e.response.data.errors.length; i++){
                                    this.alertValue = true
                                    this.alertType = 'error'
                                    if(e.response.data.errors[i].meta[0].code == 'extensionUnsupported' || e.response.data.errors[i].meta[0].code == 'fileOversize'){
                                        this.alertMsg =  i18n.t('uploadCoverError')
                                    }else {
                                        this.alertMsg = i18n.t('serverError')
                                    }
                                }
                            } else if (e.response.status == 403){
                                for(let i = 0; i < e.response.data.errors.length; i++){
                                    if(e.response.data.errors[i].detail == 'Storage is full'){
                                        this.alertValue = true
                                        this.alertType = 'error'
                                        this.alertMsg =  i18n.t('storageFullError')
                                    }
                                    else {
                                        this.$router.push({name: 'PageAccessDenied'})
                                    }
                                }
                            } else {
                                this.alertType = 'error'
                                this.alertValue = true
                                this.alertMsg =  i18n.t('serverError')       
                            }                     
                        }
                        this.loadingImage[aid] = false
                    }
                }
            }
        },
        changeRightAnswer(question, index){
            this.listQuestions.forEach(item => {
                if(item.qid == question.qid){
                    if(item.type == 1){
                        if(!item.options[index].isTrue){
                            for(var i = 0; i < item.options.length; i++){
                                item.options[i].isTrue = false
                            }
                            item.options[index].isTrue = true
                        }
                    }else{
                        if(!item.options[index].isTrue){
                            item.options[index].isTrue = true
                        }else {
                            const countRightAnswers = item.options.reduce((counter, obj) => obj.isTrue == true ? counter += 1 : counter, 0);
                            //if more that 1 right answers allow to uncheck the checkbox
                            if(countRightAnswers > 1){
                                item.options[index].isTrue = false
                            }

                        }
                    }
                    
                }
            });
        },
        showUploadQuestionImage(id){
            this.$refs.file_input_question.find(ref => ref.$attrs.ref_id === id).$refs.input.click()
        },
        showUploadAnswerImage(id){
            this.$refs.file_input_answer.find(ref => ref.$attrs.ref_id === id).$refs.input.click()
        },
        addAnswer(question){
            var questionItem = this.listQuestions.find(item => item.qid === question.qid)
            questionItem.options.push({ aid: uuid.v4(), answer: questionItem.options[0].answer == null ? null : this.exampleAnswer, image: null, imageDisplay: null, isTrue: false})
        },
        async saveQuiz(publish = false, changesOnPublished = false){
            if(publish){
                this.showImageRequiredError = false
                this.valid = this.$refs.form_questions.validate()
                if(this.valid){
                    this.listQuestions.forEach(item => {
                        item.options.forEach(item_answer => {
                            if(item_answer.answer == null && item_answer.image == null){
                                this.showImageRequiredError = true
                                this.dialogPublishVisible = false
                                this.dialogPublishChangesVisible = false
                                this.dialogNoQuestionVisible = false
                                this.alertValue = true
                                this.alertType = 'error'
                                this.alertMsg =  i18n.t('questionValidationError')
                            }
                        })
                    })
                    if(!this.showImageRequiredError){
                        this.listQuestions.forEach(item => {
                            delete item.qid
                        })

                        let data = {
                            data: {
                                type: "questions",
                                attributes: {
                                    questions: this.listQuestions,
                                    published: publish
                                },
                                relationships: {
                                    activity: {
                                        data: {
                                            type: "activities",
                                            id: this.$route.params.id
                                        }
                                    }
                                }
                            }
                        };
                        try {
                            clearInterval(this.autosaveInterval)
                            const response = await addQuestionsInActivityQuiz(this.quizId, data)

                            let dataQuiz = {
                                data: {
                                    type: "quizzes",
                                    id: this.quizId,
                                    attributes: {
                                        published: true
                                    },
                                    relationships: {
                                        activity: {
                                            data: {
                                                type: "activities",
                                                id: this.$route.params.id
                                            }
                                        }
                                    }
                                }
                            };

                            const responseQuiz = await updateActivityQuiz(this.quizId, dataQuiz)

                            if (response.status == 200 && responseQuiz.status == 200) {
                              if(this.productPlan.attributes && this.productPlan.attributes.name != 'Free'){
                                this.releaseEditor()
                              }
                              this.preventRedirect = false
                              if (changesOnPublished) {
                                this.$router.push({name: 'ViewActivityQuiz', params: {id: this.$route.params.id, quizId: this.quizId, successfullyUpdatedPublishedActivityQuiz: true}})
                              } else {
                                this.$router.push({name: 'ViewActivityQuiz', params: {id: this.$route.params.id, quizId: this.quizId, successfullyPublishedActivityQuiz: true}})
                              }
                            }
                        } catch (e) {
                            if(e.response){
                                this.dialogPublishVisible = false
                                if (e.response.status == 403){
                                    for(let i = 0; i < e.response.data.errors.length; i++){
                                        if(e.response.data.errors[i].detail == 'This action is unauthorized.'){
                                            this.$router.push({name: 'PageAccessDenied'})
                                        }
                                        else {
                                            this.alertValue = true
                                            this.alertType = 'error'
                                            this.alertMsg =  i18n.t('serverError')
                                        }
                                    }
                                } else if (e.response.status == 422){
                                    this.alertValue = true
                                    this.alertType = 'error'
                                    this.alertMsg =  i18n.t('questionValidationError')
                                } else{
                                    this.alertValue = true
                                    this.alertType = 'error'
                                    this.alertMsg =  i18n.t('serverError') 
                                }           
                            }
                        }

                    }
                }else {
                  this.dialogPublishVisible = false
                  this.dialogNoQuestionVisible = false
                  this.dialogPublishChangesVisible = false
                  this.alertValue = true
                  this.alertType = 'error'
                  this.alertMsg =  i18n.t('questionValidationError')
                }

            }else {
                this.listQuestions.forEach(item => {
                    delete item.qid
                })

                let data = {
                    data: {
                        type: "questions",
                        attributes: {
                            questions: this.listQuestions,
                            published: publish
                        },
                        relationships: {
                            activity: {
                                data: {
                                    type: "activities",
                                    id: this.$route.params.id
                                }
                            }
                        }
                    }
                };
                try{
                    clearInterval(this.autosaveInterval)
                    const response = await addQuestionsInActivityQuiz(this.quizId, data)
                    if (response.status == 200) {
                        if(this.productPlan.attributes && this.productPlan.attributes.name != 'Free'){
                          this.releaseEditor()
                        }
                        this.preventRedirect = false
                        this.$router.push({name: 'ViewActivityQuiz', params: {id: this.$route.params.id, quizId: this.quizId, successfullyUpdatedUnpublishedActivityQuiz: true}})
                    }
                } catch (e) {
                    if(e.response){
                        this.dialogNoQuestionVisible = false
                        if (e.response.status == 403){
                            for(let i = 0; i < e.response.data.errors.length; i++){
                                if(e.response.data.errors[i].detail == 'This action is unauthorized.'){
                                    this.$router.push({name: 'PageAccessDenied'})
                                }
                                else {
                                    this.alertValue = true
                                    this.alertType = 'error'
                                    this.alertMsg =  i18n.t('serverError')
                                }
                            }
                        } else if (e.response.status == 422){
                            this.alertValue = true
                            this.alertType = 'error'
                            this.alertMsg =  i18n.t('questionValidationError')
                        } else{
                            this.alertValue = true
                            this.alertType = 'error'
                            this.alertMsg =  i18n.t('serverError') 
                        }           
                    }
                }
            }
            // this.releaseEditor()
        },
        async autosaveQuizAsDraft(autosave){
            this.loadingAutosave = true
            this.loadingAutosaveFinish = false
            let data = {
                data: {
                    type: "questions",
                    attributes: {
                        questions: this.listQuestions,
                        published: false
                    },
                    relationships: {
                        activity: {
                            data: {
                                type: "activities",
                                id: this.$route.params.id
                            }
                        }
                    }
                }
            };
            await addQuestionsInActivityQuiz(this.quizId, data)
            if(autosave){
                this.loadingAutosave = false
            }else{
                this.loadingAutosave = false
                this.loadingAutosaveFinish = true
                setTimeout(() => {this.loadingAutosaveFinish = false}, 2000);
            }
        },
        removeQuestionImage(qid){
            var questionItem = this.listQuestions.find(item => item.qid === qid)
            questionItem.imageDisplay = null
            questionItem.image = null
        },
        clickOutside(){
            this.dialogPublishVisible=false;
            this.dialogNoQuestionVisible=false
        },
        preventNav(event) {
            if(this.preventRedirect){
                event.preventDefault()
                event.returnValue = ""
            }
        },
        showUploadImage(){
          this.$refs.file_input.$refs.input.click()
        },
      uploadStartImage(){
        if (this.imageData) {
          if (this.imageData.size > 5 * 1024 * 1024) {
            this.alertValue = true
            this.alertType = 'error'
            this.alertMsg =  i18n.t('uploadCoverError')
          } else {
            this.imageToCropOnUpload = URL.createObjectURL(this.imageData)
            this.imageTypeOnUpload = this.imageData.type
            this.cropOnUpload = true
            this.dialogVisibleCropper = true
          }
        }
        this.$refs.file_input.$refs.input.value = ''
      },
      cropImage(data) {
        this.imageData = data
        this.uploadStartImageServer()
        this.dialogVisibleCropper = false
        this.imageToCropOnUpload = null
      },
      closeCropImage() {
        this.dialogVisibleCropper = false
        this.imageToCropOnUpload = null
      },
      async uploadStartImageServer() {
        this.loadingUpload = true
        try {
            let data = new FormData();
            data.append('file', this.imageData);
            data.append('type', 'start');
            data.append('space_id', this.spaceId);

            const response = await uploadImageInActivityQuiz(this.quizId,data) 
            if(response.status == 200) {
                this.startUrl = response.data.meta.url
                this.startPath = response.data.meta.detail
                this.loadingUpload = false
                let dataQuiz = {
                data: {
                    type: "quizzes",
                    id: this.quizId,
                    attributes: {
                        start_image: this.startPath
                    },
                    relationships: {
                        activity: {
                            data: {
                                type: "activities",
                                id: this.$route.params.id
                            }
                        }
                    }
                }
            };

            const responseQuiz = await updateActivityQuiz(this.quizId, dataQuiz)
            if (responseQuiz.status == 200) {
                //
            }
          }
        } catch (e) {
            if(e.response){
                if (e.response.status == 422 ){
                    for(let i = 0; i < e.response.data.errors.length; i++){
                        this.alertValue = true
                        this.alertType = 'error'
                        if(e.response.data.errors[i].meta[0].code == 'extensionUnsupported' || e.response.data.errors[i].meta[0].code == 'fileOversize'){
                            this.alertMsg =  i18n.t('uploadCoverError')
                        }else {
                            this.alertMsg = i18n.t('serverError')
                        }
                    }
                } else if (e.response.status == 403){
                    for(let i = 0; i < e.response.data.errors.length; i++){
                        if(e.response.data.errors[i].detail == 'Storage is full'){
                            this.alertValue = true
                            this.alertType = 'error'
                            this.alertMsg =  i18n.t('storageFullError')
                        }
                        else {
                            this.$router.push({name: 'PageAccessDenied'})
                        }
                    }
                } else {
                    this.alertType = 'error'
                    this.alertValue = true
                    this.alertMsg =  i18n.t('serverError')       
                } 
                this.loadingUpload = false                   
            }
        }
        this.loadingUpload = false
      }
    },
    beforeRouteLeave (to, from , next) {
        if(this.preventRedirect){
            const answer = window.confirm('Do you really want to leave? Changes you made may not be saved.')
            if (answer) {
              if(this.productPlan.attributes && this.productPlan.attributes.name != 'Free'){
                this.releaseEditor();
              }
              next()
            } else {
              next(false)
            }
        }else {
            next()
        }
    },
}
        
</script>
<style>
.percent-quiz input{
    text-align: center;
}
</style>